<div class="d-flex flex-center flex-shrink-0 w-100">

  <div class="d-block d-lg-none">
    <img alt="Logo" src="/assets/images/logos/logo-dark.svg" class="h-50px my-n5 theme-light-show">
    <img alt="Logo" src="/assets/images/logos/logo-white.svg" class="h-50px my-n5 theme-dark-show">
  </div>

  <div class="flex-fill"></div>

  <!-- download -->
  <div class="app-navbar-item ms-2 d-none d-xxl-block">
    <a class="btn btn-color-gray-600 btn-light btn-active-color-primary btn-sm"
       routerLink="{{'/download'|localize}}" routerLinkActive="active">
      <bws-mdi name="microsoft-windows" class="fs-2"/> Download
    </a>
  </div>

  <!-- dwb web -->
  <div class="app-navbar-item ms-2 d-none d-md-block">
    <a class="btn btn-color-gray-600 btn-light btn-active-color-primary btn-sm"
       href="https://web.dewabit.com" target="_blank">
      <bws-mdi name="open-in-new" class="fs-2"/> dewabit web
    </a>
  </div>

  <!-- not logged in -->
  <ng-container *ngIf="!authService.isLoggedIn()">
    <div class="app-navbar-item position-relative ms-2">
      <a class="btn btn-light-primary btn-sm px-2 px-md-5 rounded-end-0" routerLink="{{'/member/login'|localize}}">
        <bws-mdi name="login" class="fs-2 me-1"/> <span class="d-none d-xxl-inline">{{'NAV-LINKS.LOGIN'|translate}}</span>
      </a>
    </div>
    <div class="app-navbar-item position-relative">
      <a class="btn btn-primary btn-sm rounded-start-0" routerLink="{{'/register'|localize}}">
        <bws-mdi name="account-plus" class="fs-2 d-none d-md-inline"/> {{'NAV-LINKS.REGISTER'|translate}}
      </a>
    </div>
  </ng-container>

  <!-- logged in -->
  <ng-container *ngIf="authService.isLoggedIn()">
    <div class="app-navbar-item position-relative ms-2" dropdown placement="bottom right">
      <div class="d-flex flex-center" dropdownToggle>
        <div class="symbol symbol-40px cursor-pointer" >
          <div class="symbol-label fs-5 fw-semibold text-white bg-primary">
            {{authService.authenticatedUser!.firstName[0]}}{{authService.authenticatedUser!.lastName[0]}}
          </div>
        </div>
        <button class="btn btn-light-primary btn-sm py-2 px-5 rounded ms-n2 btn-flush d-none d-md-block">
          {{authService.authenticatedUser?.email}}
        </button>
      </div>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right menu menu-column menu-sub menu-sub-dropdown menu-rounded fs-6 py-4 w-275px">

        <li role="menuitem" class="ps-8 my-1">
          <h4>{{authService.authenticatedUser!.firstName}} {{authService.authenticatedUser!.lastName}}</h4>
        </li>


        <li role="menuitem" class="px-5">
          <a routerLink="{{'/member/profile'|localize}}" class="dropdown-item menu-link">
            <bws-mdi name="account-details"/> {{'NAV-LINKS.MEMBER-PROFILE'|translate}}
          </a>
        </li>
        <li role="menuitem" class="px-5">
          <a routerLink="{{'/member/subscription'|localize}}" class="dropdown-item menu-link">
            <bws-mdi name="cash-multiple"/> {{'NAV-LINKS.MEMBER-SUBSCRIPTION'|translate}}
          </a>
        </li>
        <li role="menuitem" class="px-5">
          <a routerLink="{{'/member/accounts'|localize}}" class="dropdown-item menu-link">
            <bws-mdi name="account-group"/> {{'NAV-LINKS.MEMBER-EBAY-ACCOUNTS'|translate}}
          </a>
        </li>
        <li class="divider dropdown-divider"></li>
        <li role="menuitem" class="px-5">
          <a routerLink="{{'/member/login'|localize}}" class="dropdown-item menu-link fw-bold">
            <bws-mdi name="logout"/> {{'NAV-LINKS.LOGOUT'|translate}}
          </a>
        </li>
      </ul>
    </div>
  </ng-container>


</div>
